import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import {connect} from "react-redux";
import Dotdotdot from "react-dotdotdot";
import {bindActionCreators} from "redux";

import {reportArticleComment} from "../../../../creators/report";

import Avatar from '../../Avatar';
import Views from '../../Views';
import Answers from '../../Answers';
import DateSince from '../../Date';
import pictureLogo from '../../../../images/logo.png';
import createLink from "../../../../libs/createLink";
import TimelineComments from "../../comments/TimelineComments";
import Like from "../../Like/Like";
import {isNoFollowArticle, isNoFollowProfil} from "../../../../libs/helper";



class ArticleStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            isHidden: false,
        };
        this.handleReport = this.handleReport.bind(this);
    }

    handleReport(id, message){
        this.props.reportArticleComment(this.props.parentId._id, id, {message})
    }

    render() {
        let content = this.props.parentId ? this.props.parentId.excerpt : "";
        let link = createLink("article", {
            ...this.props.parentId.owner,
            article: {_id: this.props.parentId._id, slug: this.props.parentId.slug}
        });

        let relLink = isNoFollowArticle(this.props.parentId) ? { rel: "nofollow" } : {};
        let relLinkProfil = isNoFollowProfil(this.props.parentId.owner) ? { rel: "nofollow" } : {};

        let hasOwner = this.props.parentId.owner !== null && this.props.parentId.owner._id;
        return (
            <div
                className={"card article-status blog-status-card"}>
                <Fragment>
                    <div className="wrapper">
                        <div className="wrap column">
                            <div className="username row">
                                {hasOwner ? (
                                    <Link to={createLink("userProfile", this.props.parentId.owner)} {...relLinkProfil}>
                                        <Avatar avatar={this.props.parentId.owner && this.props.parentId.owner.profile.avatar}
                                                gender={this.props.parentId.owner ? this.props.parentId.owner.profile.gender : "guest"}
                                                alt=""/>
                                    </Link>
                                ) : (
                                    <Avatar gender={"guest"} />
                                )}
                                <div className="column full">
                                    <div className="row wrap full pl-0 user-detail-article">
                                        {hasOwner ? (
                                            <Link to={createLink("userProfile", this.props.parentId.owner)} {...relLinkProfil}>
                                                {this.props.parentId.owner.username}
                                            </Link>
                                        ) : (
                                            <span>{this.props.parentId.authorName}</span>
                                        )}&nbsp;
                                        {/*{this.props.type === "blog" ? `a publié dans son blog` : this.props.type === "forum" && "a publié un sujet dans le forum"}{this.props.type === "blog" && (*/}
                                        {/*<Link to={`/blog/${this.props.parentId.blog._id}-${this.props.article.blog.slug}`}>*/}
                                        {/*    &nbsp;{this.props.article.blog.title}*/}
                                        {/*</Link>)}*/}
                                         a ajouté un article
                                    </div>
                                    <span className="text small medium-grey full">
                                                    <DateSince
                                                        date={this.props.createdAt}
                                                        prefix={true}
                                                        currentFormat={true}
                                                    />
                                                </span>
                                </div>
                            </div>
                            <div className="body">
                                <div>
                                    <div className="content">
                                        <div>
                                            {this.props.parentId && this.props.parentId.cover ? (
                                                <div className="article-img"
                                                     style={{backgroundImage: `url(${this.props.parentId.cover})`}}>
                                                    <Link className="title-link-articles" to={link} {...relLink}>
                                                        {this.props.parentId && this.props.parentId.cover === null &&
                                                        <img src={pictureLogo} alt="voissa logo" loading="lazy"/>}
                                                        {this.props.parentId && this.props.parentId.cover === null &&
                                                        <span className="text medium-grey">Cet article n'a pas d'illustration</span>}
                                                    </Link>
                                                </div>
                                            ) : (
                                                <div className="article-img2">
                                                    <Link className="title-link-articles" to={link} {...relLink}>
                                                        {this.props.parentId && this.props.parentId.cover === null &&
                                                        <img src={pictureLogo} alt="voissa logo" loading="lazy"/>}
                                                        {this.props.parentId && this.props.parentId.cover === null &&
                                                        <span className="text medium-grey">Cet article n'a pas d'illustration</span>}
                                                    </Link>
                                                </div>
                                            )}

                                            <div
                                                className={"title"}>
                                                <Link to={link} {...relLink}>{this.props.parentId.title || ""}</Link>
                                            </div>
                                            <div className={`excerpt`}>
                                                <Dotdotdot clamp={"10"} useNativeClamp={false}>
                                                    {content}
                                                </Dotdotdot>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        <Views type="icon"
                               value={this.props.parentId.count && (this.props.parentId.count.view || 0)}/>
                        <Answers value={this.props.parentId.count.comment}/>
                        <Like
                            isLiked={this.props.parentId.isLiked}
                            value={this.props.parentId && (this.props.parentId.count.like || 0)}
                            likeType={"articles"}
                            parentId={this.props.parentId._id}
                        />
                    </div>
                    <TimelineComments commentsAllowed={this.props.parentId.comment.allowed}
                                      commentType={"articles"}
                                      parent={this.props.parentId}
                                      ownerId={this.props.parentId.owner._id}
                                      parentId={this.props.parentId._id}
                                      handleReport={this.handleReport}
                    />
                </Fragment>
            </div>
        )
    }
}

ArticleStatus.defaultProps = {
    title: "",
    slug: '',
    article: {
        comment: {
            allowed: false
        },
        count: {
            view: 0,
            like: 0,
            comment: 0
        }
    },
    owner: {
        _id: 0,
        slug: '',
        username: '',
        avatar: "",
        gender: ""
    },
    authorName: ""
};



const mapStateToProps = (state) => {
    return {
        currentUserId : state.currentUser.data && state.currentUser.data._id
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    reportArticleComment
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ArticleStatus);
